module.exports = __webpack_public_path__ + "static/img/image_yubi.bcba7353.png";